// Vuex UserProfiles module actions
import { API } from '@/config';

import {
  FILL_LIST,
} from './mutations-types';

export default {
  async getList({ commit }) {
    try {
      const list = (await API.get('/usersProfiles')).data.data;
      commit(FILL_LIST, { list });
    } catch (error) {
      console.log(error);
    }
  },

  async create(context, params) {
    try {
      await API.put('/usersProfiles', params);
      return Promise.resolve();
    } catch (error) {
      console.log(error);
      return Promise.reject();
    }
  },

  async update(context, params) {
    try {
      await API.post('/usersProfiles', params);
      return Promise.resolve();
    } catch (error) {
      console.log(error);
      return Promise.reject();
    }
  },

  async updatePermission(context, configuration) {
    try {
      await API.post('/usersProfiles/updatePermission', configuration);
      return Promise.resolve();
    } catch (error) {
      console.log(error);
      return Promise.reject();
    }
  },
};
